export function normalizeUrl(maybeUrl: string): string | null {
  const trimmed = maybeUrl.trim();
  if (!trimmed) return null;

  // Add scheme if missing (e.g. "youtu.be/xyz")
  const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;

  try {
    // eslint-disable-next-line no-new
    new URL(withScheme);
    return withScheme;
  } catch {
    return null;
  }
}

export function isYouTubeUrl(url: string): boolean {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./i, '').toLowerCase();
    return host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtu.be' || host === 'youtube-nocookie.com';
  } catch {
    return false;
  }
}

/**
 * Extract the first YouTube URL from a text blob.
 * Supports:
 * - https://www.youtube.com/watch?v=...
 * - https://youtu.be/...
 * - bare domains like "youtu.be/abc" (scheme will be added)
 */
export function extractFirstYouTubeUrl(text: string): string | null {
  if (!text) return null;

  // Grab URL-like tokens. Keep it forgiving; URL() validation happens later.
  const tokens = text
    .split(/\s+/)
    .map(t => t.trim().replace(/[)\].,!?;:'"]+$/g, '')) // strip common trailing punctuation
    .filter(Boolean);

  for (const token of tokens) {
    const normalized = normalizeUrl(token);
    if (!normalized) continue;
    if (isYouTubeUrl(normalized)) return normalized;
  }

  return null;
}


